import { SecureKeypad } from "components"
import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import useAuth from 'hooks/useAuth'
import useApp from 'hooks/useApp'
import Native from 'library/native'
import Lib from 'library'
import useLocalStorage from "hooks/useLocalStorage"
import Global from "library/Global"

/**
 * /data 로 이동하는 로그인
 * 2022.10.26
 */
const LoginGoData = () => {

	const App = useApp()
	const Auth = useAuth()
	const navigate = useNavigate()
	const location = useLocation()
	const [useBio, setUseBio] = useLocalStorage("useBio", false)


	const callback = async module => {

		Global.deviceInfo(() => {
			Auth.login(module, () => {
			// navigate(location.state?.from ?? "/")
			module.isOpen() && module.close()
			navigate("/data")
		})
	})
		// if (!App.test) await getDeviceInfo()
		// Auth.login(module, () => {
		// 	// navigate(location.state?.from ?? "/")
		// 	module.isOpen() && module.close()
		// 	navigate("/data")
		// })
	}

	// const getDeviceInfo = () => {
	// 	return new Promise((resolve, reject) => {
	// 		Native.execute("AppManager", "deviceInfo", result => {
	// 			const info = JSON.parse(result)
	// 			if (info.resultCode === "0") {
	// 				App.device = {
	// 					appVersion: info.result['app-version'],
	// 					model: info.result.model,
	// 					os: info.result.os,
	// 					osVersion: info.result['os-version']
	// 				}
	// 				resolve(info)
	// 			} else {
	// 				reject(info)
	// 			}
	// 		})
	// 	})
	// }

	const bioCallback = async (json) => {
		try {
			if (json.resultCode === "0") {
				//const info = await getDeviceInfo()
				Global.deviceInfo((info) => {
					const mbId = window.localStorage.getItem("mbId")
					Lib.post("/api/mb/login/bio/auth", {
						mbId: mbId,
						pushToken: info.pushToken
					}, data => {
						Auth.setUser(data)
						Auth.setIsLogin(true)
						setTimeout(() => {
							navigate(location.state?.from ?? "/data")
						}, 500)
					})
				})
			} else {
				console.error(json)
			}
		} catch (reason) {
			console.error(reason)
		}
	}

	const clearLocalStorage = () => {
		window.localStorage.removeItem("mbId")
		window.localStorage.removeItem("didRun")
		window.localStorage.removeItem("useBio");
		const cookies = window.document.cookie.split(";")
		cookies.forEach(cookie => {
			const coo = cookie.split("=")
			window.document.cookie = `${coo[0]}=;expires=Thu, 01 Jan 1970 00:00:01 GMT`
		})
	}

	useEffect(() => {
		App.setShowHeader(false)
		App.setShowNav(false)
		App.setTitle("")
		App.setAppBg("#ffffff")
	}, [])

	return (
		<div className="page flex-column">
			{App.test && <div onClick={clearLocalStorage} style={{ textAlign: "center", zIndex: 1, marginTop: "10rem" }}>(개발) 로컬 스토리지, 캐시 비우기</div>}
			<input type="hidden" id="passInput" />
			<SecureKeypad input="passInput" more={useBio} callback={callback} bioCallback={bioCallback} autoClose={false} bio={true}/>
		</div>
	)
}

export default LoginGoData
